/**
 * The `environment` parameter every IDP template declares, as the enum the
 * template schemas constrain it to.
 *
 * It lives here rather than in the app because both sides of the UI need it:
 * the app's My stacks table filters and sorts on it, and the stack-entity
 * plugin puts it on the General card. The platform's own value is what is kept
 * and passed around - `prd` is what the API says and what a Terraform user
 * types - and the label is only ever for display.
 */
export const ENVIRONMENT_LABELS: Record<string, string> = {
  dev: 'Development',
  tst: 'Test',
  stg: 'Staging',
  prd: 'Production',
};

/** Deployment order, so a facet reads dev to prd rather than alphabetically. */
export const ENVIRONMENT_ORDER = ['dev', 'tst', 'stg', 'prd'];

/**
 * The tier a stack was provisioned into, or undefined when its template never
 * asked for one - the parameter is per-template, and an environment created
 * before its template declared it keeps the parameters it was created with.
 */
export const environmentOfParameters = (
  parameters: unknown,
): string | undefined => {
  if (!parameters || typeof parameters !== 'object') return undefined;
  const value = (parameters as Record<string, unknown>).environment;
  return typeof value === 'string' && value ? value : undefined;
};

/** The tier in plain language, falling back to the raw value for a new tier. */
export const environmentLabel = (tier: string): string =>
  ENVIRONMENT_LABELS[tier] ?? tier;
